import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom"; // Change useHistory to useNavigate
import "./About.css";

export default function AboutBTUI() {
  const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    // Scroll-triggered animations with better performance
    const observerOptions = {
      threshold: 0.15,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !entry.target.classList.contains('revealed')) {
          entry.target.classList.add('revealed');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    // Observe all animatable elements
    const animatableSelectors = [
      '.about-section',
      '.stat-item',
      '.section-text',
      '.house-card',
      '.category-tag',
      '.about-file-info span'
    ];

    animatableSelectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(element => {
        element.classList.add('animate-on-scroll');
        observer.observe(element);
      });
    });

    return () => observer.disconnect();
  }, []);

  const handleCardClick = (houseName) => {
    navigate(`/competitions/${houseName}`); // Use navigate instead of history.push
  };

  return (
    <div className="about-container">
      <div className="about-container-outer">
        <div className="about-container-inner">
          {/* Hero Section */}
          <div className="about-hero">
        <div className="about-header-label">
          <span className="char">B</span>
          <span className="char">T</span>
          <span className="char">U</span>
          <span className="char">I</span>
          <span className="char">'</span>
          <span className="char">2</span>
          <span className="char">6</span>
        </div>
        
        <h1 className="about-hero-title">
          <span className="word">Beyond</span>
          <span className="word">THE</span>
          <span className="word">USER</span>
          <span className="word">INTERFACE</span>
        </h1>
        <div className="about-hero-description">
          <p className="desc-line">
            Beyond the User Interface 2026 (BTUI 2026), the Annual ICT Day of Royal College organized by the Royal College Computer Society, stands as one of the premier technology events in the school calendar. Celebrating the transformation of technology from luxury to necessity, the event unites students from leading schools, tech enthusiasts, and industry figures in a vibrant showcase of innovation and collaboration.
          </p>
          <p className="desc-line">
            Adopting a futuristic theme inspired by robotics and intelligent systems, BTUI 2026 explores the synergy between humans and technology while sparking curiosity about its limitless possibilities. The program features nationwide online competitions in programming, web development, design, video editing, and ICT quizzes, leading to the grand ICT Day at Royal College with an exclusive tech showcase and prize-giving — a true celebration of talent, creativity, and the future of ICT.
          </p>
        </div>
      </div>

      {/* About BTUI Section */}
      <div className="about-section">
        <div className="section-label">ABOUT BTUI</div>
        <div className="section-content">
          <h2 className="section-title">REDEFINING TECH COMPETITIONS</h2>
          {/* You can keep or update this section as needed */}
        </div>
      </div>

      {/* Avenues Section */}
      <div className="about-section houses-section">
        <div className="section-label">OUR AVENUES</div>
        <div className="houses-grid">
          <div className="house-card" onClick={() => handleCardClick('ARMITAGE')}>
            <div className="house-number">01</div>
            <h3 className="house-name">ARMITAGE</h3>
            <div className="house-line"></div>
            <p className="house-description">
              Programming excellence through algorithm challenges, problem-solving, 
              and web development competitions.
            </p>
            <div className="house-categories">
              <span className="category-tag">Algorithm</span>
              <span className="category-tag">Problem Solving</span>
              <span className="category-tag">Web Development</span>
            </div>
          </div>

          <div className="house-card" onClick={() => handleCardClick('INSIGNIA')}>
            <div className="house-number">02</div>
            <h3 className="house-name">INSIGNIA</h3>
            <div className="house-line"></div>
            <p className="house-description">
              Creative design mastery across photo manipulation, poster design, 
              logo creation, and UI/UX excellence.
            </p>
            <div className="house-categories">
              <span className="category-tag">Photo Manipulation</span>
              <span className="category-tag">Poster Design</span>
              <span className="category-tag">Logo Design</span>
              <span className="category-tag">UI/UX Design</span>
            </div>
          </div>

          <div className="house-card" onClick={() => handleCardClick('ZENITH')}>
            <div className="house-number">03</div>
            <h3 className="house-name">ZENITH</h3>
            <div className="house-line"></div>
            <p className="house-description">
              Hardware innovation through line-following robotics and groundbreaking 
              innovation challenges.
            </p>
            <div className="house-categories">
              <span className="category-tag">Line Following Bot</span>
              <span className="category-tag">Innovation Challenge</span>
            </div>
          </div>

          <div className="house-card" onClick={() => handleCardClick('ORTHODOX')}>
            <div className="house-number">04</div>
            <h3 className="house-name">ORTHODOX</h3>
            <div className="house-line"></div>
            <p className="house-description">
              Knowledge competition testing tech expertise across multiple domains 
              in our inter-school quiz challenge.
            </p>
            <div className="house-categories">
              <span className="category-tag">Inter School Quiz</span>
            </div>
          </div>
        </div>
      </div>

      {/* Stats Section */}
      <div className="about-stats">
        <div className="stat-item">
          <div className="stat-number">10+</div>
          <div className="stat-label">COMPETITIONS</div>
        </div>
        <div className="stat-item">
          <div className="stat-number">500+</div>
          <div className="stat-label">PARTICIPANTS</div>
        </div>
        <div className="stat-item">
          <div className="stat-number">50+</div>
          <div className="stat-label">SCHOOLS</div>
        </div>
      </div>

      {/* File Info Footer */}
      <div className="about-file-info">
        <span>A</span>
        <span>1</span>
        <span>U</span>
        <span>MH</span>
        <span>YVR24_</span>
        <span className="file-number">FILE NUMBER: 212</span>
        
      </div>
        </div>
      </div>
    </div>
  );
}
